import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from '../../services/auth.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username: string;
  password: string;

  constructor(private toastr: ToastrService, private router: Router, private activatedRoute: ActivatedRoute, private cookieService: CookieService, private authService: AuthService) {
    if (this.cookieService.check('API_TOKEN')) {

    }
  }

  ngOnInit() {
  }

  /**
   * Kick in the login mechanism and authenticate user
   */
  doLogin() {
    if (this.username && this.password && this.username !== '' && this.password !== '') {
      if (this.username.toLowerCase().indexOf('@thorogood.com') < 0) {
        this.toastr.error( 'Please enter valid email address', 'Sorry!!!' );
      } else if (this.username.toLowerCase().split('@thorogood.com')[0] !== this.username.toLowerCase().replace('@thorogood.com', '' )) {
        this.toastr.error( 'Please enter valid domain name', 'Sorry!!!' );
      } else {
        this.toastr.clear();
        setTimeout(() => this.toastr.info('Contacting Thorogood Domain Controller for authentication', 'Please wait...'));
        this.authService.doLogin(this.username.toLowerCase().split('@thorogood.com')[0].substr(0,  (this.username.toLowerCase().split('@thorogood.com')[0].length < 20) ? this.username.toLowerCase().split('@thorogood.com')[0].length : 20), this.password).subscribe(value => {
          this.cookieService.set('API_TOKEN', value, 0.5, null, null, null);
          SessionService.apiToken = value;
          this.authService.getUser().subscribe(value2 => {
            SessionService.user = value2;
            this.toastr.clear();
            this.activatedRoute.queryParams.subscribe(params => {
              if (params.hasOwnProperty('next')) {
                this.router.navigate([params['next']]);
              } else {
                this.router.navigate(['/root/dashboard']);
              }
            });

          }, (err: HttpErrorResponse) => {
            this.toastr.clear();
            console.log('Error :' + JSON.stringify(err));
            setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in User Retrieval : Code ' + err.status));
          });
        }, (err: any) => {
          this.toastr.clear();
          console.log('Error :' + JSON.stringify(err));
          if (err.hasOwnProperty('error')) {
            setTimeout(() => this.toastr.error('' + err.error.detail, 'Sorry'));
          } else {
            setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in Loging you in : Code ' + err.status));
          }
        });
      }
    } else {
      this.toastr.clear();
      this.toastr.error('Please enter Credentials...', 'Sorry!!!');
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/login/login.component.ts